import { SCREEN_SIZES } from 'modules/utils/screenSizes';
import { useMediaQuery } from 'react-responsive';
import { DesktopMediaPlatform } from './MediaPlatform.desktop';
import { MobileMediaPlatform } from './MediaPlatform.mobile';

export const MediaPlatform = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${SCREEN_SIZES.mobile})`,
  });

  if (isMobile) return <MobileMediaPlatform />;

  return <DesktopMediaPlatform />;
};
